import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';

const LinearProgressBar = ({color}) => {
    return (
        <LinearProgress />
    )
}

export default LinearProgressBar
